<script>
import {getFormat} from "../helpers/format.helper";
import EditableCell from "./EditableCell.svelte";
import AlteryxService from "../services/alteryx.service";
import {onMount} from "svelte";
import Loader from "./Loader.svelte";

let activityCodes = [];
let loadingExport = false;
let filter = '';
let loading = true;
let loadingCodes = true;
let errorMessage = '';
let isAllowed = false;

const codes = ["1","8","29","30","44"];
let sortBy = "kpis.id";
let order = true;
let headers = [
    {title: "KPI ID", key: "kpis.id"},
    {title: "KPI NAME", key: "kpis.title" },
    {title: "ROLE", key: "role"},
    {title: "REPORT", key: "kpis.type" },
    {title: "COMPANY", key: "organization"},
    {title: "FORMAT", key: "kpis.format" },
    {title: "GROUP CODE", key: "kpis.code" }
];

onMount( async () => {
    await loadAlteryxCatalog();
});

async function loadAlteryxCatalog() {
    errorMessage = null;
    loading = true;
    activityCodes = [];

    try {
        loadingCodes = true;
        const response = await AlteryxService.load({sortBy, order});

        if (response && response.codes) {
            activityCodes = response.codes;
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loading = false;
        loadingCodes = false;
    }
}

function updateList(e) {
    filter = e.target.value.toString().toLowerCase();
}

function sort(key){
    order = (sortBy === key)? !order : true;
    sortBy = key;
    loadAlteryxCatalog();
}

let updateGroupCode = async function(code, id){
    try {
        await ReportsService.updateKpi({code, id});
        jQuery('.cellSelected').removeClass('cellSelected');
    } catch (e) {
        errorMessage = e.message;
    }
}

let exportList = async function(page){
    loadingExport = true;
    try {
        const response = await AlteryxService.export(page);
        if(!response) return false;
        var fields = Object.keys(response[0])
        var replacer = function(key, value) { return value === null ? '' : value }
        var csv = response.map(function(row){
            return fields.map(function(fieldName){
                return JSON.stringify(row[fieldName], replacer)
            }).join(',')
        })
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');
        // Download file
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "alteryx-" + page + ".csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loadingExport = false;
    }
}
</script>

{#if loadingCodes}
    <Loader fixed={false}></Loader>
{:else}
<div class="row">
    <div class="col-10">
        <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Search..." on:keyup={updateList}>
        </div>
    </div>
    <div class="col-2">
        <div class="input-group mb-3 w-auto float-right">
            <button class="btn btn-primary" on:click={() => exportList('codes')}>
                {#if loadingExport}
                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                {:else}
                    <img src="/img/csv.svg" alt="csv-icon" class="icon">
                {/if}
                EXPORT
            </button>
        </div>
    </div>
    <div class="col-12">
        {#if activityCodes.length > 0}
            <table class="table table-responsive table-scrollable">
                <thead>
                {#each headers as header}
                    <th class="pointer align-top" on:click={() => sort(header.key)}>
                        {header.title}
                        <i class="fa fa-sort-{(sortBy === header.key && !order) ? 'desc' : 'asc' } {(sortBy === header.key) ? 'text-primary' : '' }"></i>
                    </th>
                {/each}
                </thead>
                <tbody>
                {#each activityCodes as item}
                    {#if filter = '' || item.id.toString().toLowerCase().indexOf(filter) >= 0 || item.title.toString().toLowerCase().indexOf(filter) >= 0
                        || item.role.toString().toLowerCase().indexOf(filter) >= 0 || item.type.toString().toLowerCase().indexOf(filter) >= 0
                        || item.organization.toString().toLowerCase().indexOf(filter) >= 0 || getFormat(item.format).toString().toLowerCase().indexOf(filter) >= 0
                        || (item.code && item.code.toString().toLowerCase().indexOf(filter) >= 0) }
                        <tr>
                            <td id="col-kpis-kpiId">{item.id}</td>
                            <td id="col-kpis-kpiNameColumn">
                                {item.title}
                                {#if codes.includes(item.code)}
                                    <i data-toggle="tooltip" data-placement="right" title="This KPI is displayed in the Charts section" class="ml-1 fa fa-bar-chart  text-primary"></i>
                                {/if}
                            </td>
                            <td id="col-kpis-role">{item.role}</td>
                            <td id="col-kpis-report">{(item.type == 0)?'Weekly' : (item.type == 1) ? 'Monthly' : 'SDR'}</td>
                            <td id="col-kpis-organization">{item.organization}</td>
                            <td id="col-kpis-format" >{getFormat(item.format)}</td>
                            <td id="col-kpis-code">
                                <EditableCell
                                    on:change={(e) => updateGroupCode(e.detail.value, item.id)}
                                    format={8}
                                    customClass={'no-outline'}
                                    bind:value={item.code}></EditableCell>
                            </td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="alert alert-primary">
                <i class="fa fa-info-circle fa-3x text-primary"></i>
                <h4 class="text-primary text-uppercase pt-3">
                    No codes were found!
                </h4>
            </div>
        {/if}
    </div>
</div>
{/if}
